const stripe = require("stripe")(process.env.REACT_APP_STRIPE_TEST_KEY);

console.log(stripe, process.env.REACT_APP_STRIPE_TEST_KEY);
// Helper function to determine if payment is one-time
const isOneTimePayment = (title) => title === "A La Carte";

// Helper function to get base URL
const getBaseUrl = () => {
  return window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : `${window.location.protocol}//${window.location.hostname}`;
};

// Helper function to create line items
const createLineItems = (price, title, isOneTime, interval) => {
  return [
    {
      price_data: {
        currency: "usd",
        unit_amount: price * 100,
        ...(isOneTime
          ? {} // No recurring data for one-time payments
          : {
              recurring: {
                interval: interval,
              },
            }),
        product_data: {
          name: title,
        },
      },
      quantity: 1,
    },
  ];
};

// Helper function to create metadata
const createMetadata = (
  uid,
  title,
  isOneTime,
  dish_tokens,
  recipe_tokens,
  interval
) => {
  const baseMetadata = {
    userId: uid,
    plan: title,
    paymentType: isOneTime ? "one-time" : "subscription",
    dish_tokens,
    recipe_tokens,
  };

  if (!isOneTime) {
    baseMetadata.interval = interval;
  }

  return baseMetadata;
};

// Helper function to create payment intent data
const createPaymentIntentData = (uid, title, dish_tokens, recipe_tokens) => {
  return {
    payment_intent_data: {
      metadata: {
        userId: uid,
        plan: title,
        dish_tokens,
        recipe_tokens,
        paymentType: "one-time",
      },
    },
  };
};

// Helper function to create subscription data
const createSubscriptionData = (
  uid,
  title,
  interval,
  dish_tokens,
  recipe_tokens
) => {
  return {
    subscription_data: {
      metadata: {
        userId: uid,
        subScriptionPlan: title,
        interval,
        dish_tokens,
        recipe_tokens,
        paymentType: "subscription",
      },
    },
  };
};

const stripeCheckoutSession = async (
  price,
  title,
  uid,
  dish_tokens,
  recipe_tokens,
  interval = "month"
) => {
  const isOneTime = isOneTimePayment(title);
  const baseUrl = getBaseUrl();
  const line_items = createLineItems(price, title, isOneTime, interval);
  const metadata = createMetadata(
    uid,
    title,
    isOneTime,
    dish_tokens,
    recipe_tokens,
    interval
  );

  const sessionConfig = {
    line_items,
    allow_promotion_codes: true,
    mode: isOneTime ? "payment" : "subscription",
    client_reference_id: uid,
    metadata,
    success_url: `${baseUrl}/success`,
    cancel_url: `${baseUrl}/shop`,
  };

  // Add payment-specific data based on payment type
  if (isOneTime) {
    sessionConfig.payment_intent_data = createPaymentIntentData(
      uid,
      title,
      dish_tokens,
      recipe_tokens
    ).payment_intent_data;
  } else {
    sessionConfig.subscription_data = createSubscriptionData(
      uid,
      title,
      interval,
      dish_tokens,
      recipe_tokens
    ).subscription_data;
  }

  const session = await stripe.checkout.sessions.create(sessionConfig);
  return session;
};

export { stripeCheckoutSession };
